<!-- ─── KPI Summary ─────────────────────────────────────────────────────── -->
<drill-kpi-summary
  [sessions]="blast().sessions"
  [targetMeters]="blast().targetMeters">
</drill-kpi-summary>

<!-- ─── Sessions Table / Empty State ────────────────────────────────────── -->
@if (hasSessions()) {

  <div class="section-header">
    <h3 class="section-title">Drilling Sessions</h3>
    <button mat-stroked-button color="primary" (click)="onAddSession()">
      <mat-icon>add</mat-icon> Add Session
    </button>
  </div>

  <div class="table-container">
    <mat-table
      [dataSource]="sortedSessions()"
      matSort
      [matSortActive]="sortActive()"
      [matSortDirection]="sortDirection()"
      (matSortChange)="onSortChange($event)"
      class="sessions-table">

      <!-- # column -->
      <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
        <td mat-footer-cell *matFooterCellDef class="footer-label">Total</td>
      </ng-container>

      <!-- Rig column -->
      <ng-container matColumnDef="rig">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="rig">Drill Rig</th>
        <td mat-cell *matCellDef="let row"><strong>{{ row.equipmentLabel }}</strong></td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Operator column -->
      <ng-container matColumnDef="operator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="operator">Operator</th>
        <td mat-cell *matCellDef="let row">{{ row.operatorLabel }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Shift column -->
      <ng-container matColumnDef="shift">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="shift">Shift</th>
        <td mat-cell *matCellDef="let row">
          <span class="shift-chip" [class]="shiftCssClass(row.shiftIndex)">
            {{ shiftLabel(row.shiftIndex) }}
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Date column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="date">Date</th>
        <td mat-cell *matCellDef="let row">{{ row.date }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Shift Duration column -->
      <ng-container matColumnDef="shiftDuration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="shiftDuration">Shift Duration</th>
        <td mat-cell *matCellDef="let row">{{ row.shiftDurationHours | number:'1.1-1' }} h</td>
        <td mat-footer-cell *matFooterCellDef>{{ footerTotalShiftDuration() | number:'1.1-1' }} h</td>
      </ng-container>

      <!-- Engine Hours column -->
      <ng-container matColumnDef="engineHours">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="engineHours">Engine Op. Hours</th>
        <td mat-cell *matCellDef="let row">{{ row.engineHours | number:'1.1-1' }} h</td>
        <td mat-footer-cell *matFooterCellDef>{{ footerTotalEngineHours() | number:'1.1-1' }} h</td>
      </ng-container>

      <!-- Pause Hours column -->
      <ng-container matColumnDef="pauseHours">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="pauseHours">Pause Duration</th>
        <td mat-cell *matCellDef="let row">{{ formatPause(row.pauseHours) }}</td>
        <td mat-footer-cell *matFooterCellDef>{{ formatPause(footerTotalPauseHours()) }}</td>
      </ng-container>

      <!-- Drilled Meters column -->
      <ng-container matColumnDef="drilledMeters">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="drilledMeters">Drilled Length</th>
        <td mat-cell *matCellDef="let row">
          <span class="drill-bar-wrap"
            [matTooltip]="row.drilledMeters + ' m drilled / ' + blast().targetMeters + ' m target'">
            <span class="drill-bar-track">
              <span class="drill-bar-fill" [style.width]="sessionBarWidthPx(row.drilledMeters)"></span>
            </span>
          </span>
          {{ row.drilledMeters | number:'1.0-0' }} m
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>{{ footerTotalDrilled() | number:'1.0-0' }} m</strong>
        </td>
      </ng-container>

      <!-- Actions column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="rowMenu" aria-label="Session actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #rowMenu="matMenu">
            <button mat-menu-item (click)="onEditSession(row)">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <!-- <button mat-menu-item (click)="onDeleteSession(row)" class="menu-item-danger">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button> -->
          </mat-menu>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Row definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true" class="footer-row"></tr>
    </mat-table>
  </div>
  

} @else {

  <!-- ─── Empty State ──────────────────────────────────────────────────── -->
  <div class="empty-state">
    <mat-icon class="empty-icon">construction</mat-icon>
    <p class="empty-text">No drilling sessions recorded yet</p>
    <button mat-stroked-button color="primary" (click)="onAddSession()">
      <mat-icon>add</mat-icon> Add Session
    </button>
  </div>

}
